var _path, _path2, _g, _g2, _path3, _g3, _g4, _g5, _g6, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeRecommended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 104,
    viewBox: "0 0 203 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.894 53.3937H82.3299L69 100.589C69 100.589 75.2435 103.699 93.1086 103.699C110.974 103.699 117.217 100.589 117.217 100.589L103.894 53.3937ZM104.988 30.4374L103.448 50.5805H82.7671L81.2297 30.4608L85.1815 27C85.3452 30.4374 87.3328 36.9615 93.132 36.9615C98.9312 36.9615 100.919 30.4374 101.082 27L104.988 30.4374Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597:5949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 27,
    width: 49,
    height: 77
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.894 53.3937H82.3299L69 100.589C69 100.589 75.2435 103.699 93.1086 103.699C110.974 103.699 117.217 100.589 117.217 100.589L103.894 53.3937ZM104.988 30.4374L103.448 50.5805H82.7671L81.2297 30.4608L85.1815 27C85.3452 30.4374 87.3328 36.9615 93.132 36.9615C98.9312 36.9615 100.919 30.4374 101.082 27L104.988 30.4374Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597:5949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8545 51.5062C84.8545 86.4649 43.2782 94.3686 72.1571 123.248",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8713 51.5062C90.2097 85.8803 51.2524 97.1746 79.383 122.827",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8642 51.5062C95.5409 85.2957 59.226 99.9807 86.585 122.406",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8572 51.5062C100.849 84.7111 67.1764 102.787 93.7637 121.961",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8741 51.5062C106.204 84.1499 75.174 105.593 100.99 121.54",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8673 51.5062C111.536 83.5653 83.1245 108.422 108.192 121.12",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86 51.5062C116.867 82.9807 91.0745 111.228 115.394 120.675",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.853 51.5062C122.198 82.3961 99.0484 114.034 122.572 120.254",
    stroke: "#95D1EB",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_597:5949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.437 42.6022H182.584L180.978 50.101H168.043L166.437 42.6022Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.437 42.6022H182.584L180.978 50.101H168.043L166.437 42.6022Z",
    stroke: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.339 46.3607H181.782L180.979 50.101H168.043L167.24 46.3607H158.683L153.21 71.9404H195.812L190.339 46.3607Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_597:5949",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 44,
    width: 58,
    height: 33
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597:5949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.454 74.7792L202.904 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 76.2112L202.904 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 74.7792L194.931 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 76.2112L194.931 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 74.7792L186.958 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 76.2112L186.958 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 74.7792L178.986 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 76.2112L178.986 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 74.7792L171.014 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 76.2112L171.014 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 74.7792L163.041 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 76.2112L163.041 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 74.7792L155.068 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 76.2112L155.068 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 74.7792L147.096 76.2112",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 76.2112L147.096 74.7792",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 67.1418L202.904 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 68.5738L202.904 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 67.1418L194.931 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 68.5738L194.931 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 67.1418L186.958 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 68.5738L186.958 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 67.1418L178.986 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 68.5738L178.986 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 67.1418L171.014 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 68.5738L171.014 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 67.1418L163.041 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 68.5738L163.041 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 67.1418L155.068 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 68.5738L155.068 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 67.1418L147.096 68.5738",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 68.5738L147.096 67.1418",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 59.5044L202.904 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 60.9364L202.904 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 59.5044L194.931 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 60.9364L194.931 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 59.5044L186.958 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 60.9364L186.958 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 59.5044L178.986 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 60.9364L178.986 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 59.5044L171.014 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 60.9364L171.014 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 59.5044L163.041 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 60.9364L163.041 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 59.5044L155.068 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 60.9364L155.068 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 59.5044L147.096 60.9364",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 60.9364L147.096 59.5044",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 51.8671L202.904 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 53.2991L202.904 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 51.8671L194.931 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 53.2991L194.931 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 51.8671L186.958 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 53.2991L186.958 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 51.8671L178.986 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.536 53.2991L178.986 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 51.8671L171.014 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 53.2991L171.014 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 51.8671L163.041 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 53.2991L163.041 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 51.8671L155.068 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 53.2991L155.068 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 51.8671L147.096 53.2991",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.646 53.2991L147.096 51.8671",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 44.2297L202.904 45.6617",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 45.6617L202.904 44.2297",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 44.2297L194.931 45.6617",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.481 45.6617L194.931 44.2297",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 44.2297L186.959 45.6617",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.509 45.6617L186.959 44.2297",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 44.2297L163.041 45.6617",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.591 45.6617L163.041 44.2297",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 44.2297L155.068 45.6617",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.619 45.6617L155.068 44.2297",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.647 44.2304L147.097 45.6624",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.647 45.6624L147.097 44.2304",
    stroke: "#79CCF3",
    strokeMiterlimit: 10
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_597:5949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.338 46.3607H181.781L180.979 50.101H168.043L167.24 46.3607H158.683L153.209 71.9404H195.812L190.338 46.3607Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_597:5949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82129 52.9798L7.48458 69.6127H9.97952C9.97952 67.5138 8.27536 58.7751 12.4745 60.1081L5.82129 52.9798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82129 52.9798L7.48458 69.6127H9.97952C9.97952 67.5138 8.27536 58.7751 12.4745 60.1081L5.82129 52.9798Z",
    stroke: "white",
    strokeOpacity: 0.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_597:5949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1582 44.6633H9.32365L12.8997 50.121L23.2306 62.5957L31.1775 60.6465L39.919 69.6127H20.8466L5.74757 53.2396L4.1582 44.6633Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1582 44.6633H9.32365L12.8997 50.121L23.2306 62.5957L31.1775 60.6465L39.919 69.6127H20.8466L5.74757 53.2396L4.1582 44.6633Z",
    stroke: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 3L92 7L98 1",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3L14 7L20 1",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170 3L174 7L180 1",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_597:5949",
    x: 161.819,
    y: 38.1022,
    width: 25.3833,
    height: 16.4987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_597:5949"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_597:5949",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_597:5949",
    x: 1.17627,
    y: 47.556,
    width: 16.9658,
    height: 26.5567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_597:5949"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_597:5949",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_597:5949",
    x: -0.442871,
    y: 40.1633,
    width: 45.5479,
    height: 33.9494,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_597:5949"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_597:5949",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597:5949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.4507,
    height: 32.1724,
    fill: "white",
    transform: "translate(145.549 44.1342)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeRecommended);
export default __webpack_public_path__ + "static/media/facade-recommended.439b5d16.svg";
export { ForwardRef as ReactComponent };